'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.liveAdminOnEnterSaga = exports.liveOnEnterSaga = exports.videosOnEnterSaga = exports.liveSellPageOnEnterSaga = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _bound = require('redux/saga/entities/bound');

var _helpers = require('redux/saga/helpers');

var _selectors = require('redux/saga/selectors');

var _loginRedirectUrl = require('helpers/loginRedirectUrl');

var _loginRedirectUrl2 = _interopRequireDefault(_loginRedirectUrl);

var _memberStatus = require('enums/memberStatus');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var liveSellPageOnEnterSaga = /*#__PURE__*/exports.liveSellPageOnEnterSaga = _regenerator2.default.mark(function liveSellPageOnEnterSaga() {
  return _regenerator2.default.wrap(function liveSellPageOnEnterSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.call)(_helpers.scrollToTop);

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, liveSellPageOnEnterSaga, this);
});

var videosOnEnterSaga = /*#__PURE__*/exports.videosOnEnterSaga = _regenerator2.default.mark(function videosOnEnterSaga(client, nextState, replaceState) {
  var redirect = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '/';
  var profile, permissions, isActiveMember, isLivePermissioned;
  return _regenerator2.default.wrap(function videosOnEnterSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.select)(_selectors.isLoggedIn);

        case 2:
          if (_context2.sent) {
            _context2.next = 6;
            break;
          }

          _context2.next = 5;
          return (0, _effects.call)(replaceState, (0, _loginRedirectUrl2.default)(nextState.location));

        case 5:
          return _context2.abrupt('return', _context2.sent);

        case 6:
          _context2.next = 8;
          return (0, _effects.call)(_helpers.scrollToTop);

        case 8:
          _context2.next = 10;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userProfile, [client]);

        case 10:
          profile = _context2.sent;
          _context2.next = 13;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userPermissions, [client, profile.id]);

        case 13:
          permissions = _context2.sent;
          isActiveMember = profile.membership.status === (0, _memberStatus.memberStatus)('ACTIVE');
          isLivePermissioned = permissions.feature_videos_live_tests;

          if (!(isActiveMember || isLivePermissioned)) {
            _context2.next = 18;
            break;
          }

          return _context2.abrupt('return');

        case 18:
          _context2.next = 20;
          return (0, _effects.call)(replaceState, redirect);

        case 20:
          return _context2.abrupt('return', _context2.sent);

        case 21:
        case 'end':
          return _context2.stop();
      }
    }
  }, videosOnEnterSaga, this);
});

var liveOnEnterSaga = /*#__PURE__*/exports.liveOnEnterSaga = _regenerator2.default.mark(function liveOnEnterSaga(client, nextState, replaceState) {
  var redirect = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '/';
  var profile, permissions;
  return _regenerator2.default.wrap(function liveOnEnterSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.select)(_selectors.isLoggedIn);

        case 2:
          if (_context3.sent) {
            _context3.next = 6;
            break;
          }

          _context3.next = 5;
          return (0, _effects.call)(replaceState, (0, _loginRedirectUrl2.default)(nextState.location));

        case 5:
          return _context3.abrupt('return', _context3.sent);

        case 6:
          _context3.next = 8;
          return (0, _effects.call)(_helpers.scrollToTop);

        case 8:
          _context3.next = 10;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userProfile, [client]);

        case 10:
          profile = _context3.sent;
          _context3.next = 13;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userPermissions, [client, profile.id]);

        case 13:
          permissions = _context3.sent;

          if (!permissions.feature_videos_live_tests) {
            _context3.next = 16;
            break;
          }

          return _context3.abrupt('return');

        case 16:
          _context3.next = 18;
          return (0, _effects.call)(replaceState, redirect);

        case 18:
          return _context3.abrupt('return', _context3.sent);

        case 19:
        case 'end':
          return _context3.stop();
      }
    }
  }, liveOnEnterSaga, this);
});

var liveAdminOnEnterSaga = /*#__PURE__*/exports.liveAdminOnEnterSaga = _regenerator2.default.mark(function liveAdminSaga(client, nextState, replaceState) {
  var profile, permissions;
  return _regenerator2.default.wrap(function liveAdminSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.select)(_selectors.isLoggedIn);

        case 2:
          if (_context4.sent) {
            _context4.next = 6;
            break;
          }

          _context4.next = 5;
          return (0, _effects.call)(replaceState, (0, _loginRedirectUrl2.default)(nextState.location));

        case 5:
          return _context4.abrupt('return', _context4.sent);

        case 6:
          _context4.next = 8;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userProfile, [client]);

        case 8:
          profile = _context4.sent;
          _context4.next = 11;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userPermissions, [client, profile.id]);

        case 11:
          permissions = _context4.sent;

          if (permissions.feature_admin_video_kiosk) {
            _context4.next = 16;
            break;
          }

          _context4.next = 15;
          return (0, _effects.call)(replaceState, '/');

        case 15:
          return _context4.abrupt('return', _context4.sent);

        case 16:
        case 'end':
          return _context4.stop();
      }
    }
  }, liveAdminSaga, this);
});